<section class="main-content">
  @if (icon) {
    <div class="icon">
      <svg-icon [src]="icon" [stretch]="true"></svg-icon>
    </div>
  }

  @if (questionTranslationKey) {
    <div class="question">
      <app-text [text]="questionTranslationKey" [textParameters]="questionTranslationParams"></app-text>
    </div>
  }

  @if (aftermathTranslationKey) {
    <div class="aftermath">
      <span class="block" [innerHTML]="aftermathTranslationKey | translate: aftermathTranslationParams"></span>
    </div>
  }

  @if (aftermathTemplate) {
    <div class="aftermath">
      <ng-container *ngTemplateOutlet="aftermathTemplate"></ng-container>
    </div>
  }
</section>
<section class="footer flex flex-row-reverse justify-between bg-navy-30 items-center px-8 h-20">
  <div class="buttons flex" [class.primary-first]="primaryButtonFirst">
    @if (confirmTranslationKey) {
      <app-new-button
        class="{{ confirmButtonClasses }} min-w-40"
        data-test-id="confirm-btn"
        [type]="'primary'"
        [size]="'responsive'"
        [svgIconPath]="confirmIcon ? confirmIcon : isConfirmTranslationKeyShouldBeChanged && iconPathAfterConfirming"
        [loading]="isLoading"
        [disabled]="!isConfirmationValid"
        (click)="confirm()"
      >
        {{ modifiedConfirmTranslationKey | translate }}
      </app-new-button>
    }

    @if (dismissTranslationKey) {
      <app-new-button
        class="{{ confirmButtonClasses }} min-w-40"
        data-test-id="dismiss-btn"
        [attr.id]="dismissButtonId"
        [type]="'secondary'"
        [size]="'responsive'"
        [disabled]="isLoading"
        [svgIconPath]="dismissIcon"
        (click)="dismiss()"
      >
        {{ dismissTranslationKey | translate }}
      </app-new-button>
    }
  </div>
  @if (localStorageKey) {
    <app-checkbox
      [valueLabel]="dontShowTranslationKey | translate"
      (changeValue)="changeValue($event.checked)"
    ></app-checkbox>
  }
</section>
